import React, { useState } from 'react';
import { TabContent, TabPane } from 'reactstrap';
import { VENDOR_ORDERS_TABS } from 'utils/constants';
import CustomTabs from 'components/CustomTabs';
import VendorOrderSoldAndPurchase from './components/VendorOrderSoldAndPurchase';
import VendorOrderPayment from './components/VendorOrderPayment';

const VendorOrders = () => {
  const [activeTab, setActiveTab] = useState(
    VENDOR_ORDERS_TABS.SOLD_AND_PURCHASE,
  );

  const toggle = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  return (
    <div>
      {' '}
      <CustomTabs
        className="full-border-tab"
        tabs={[
          VENDOR_ORDERS_TABS.SOLD_AND_PURCHASE,
          VENDOR_ORDERS_TABS.PAYMENT,
        ]}
        selectedTab={activeTab}
        onTabChange={toggle}
      />
      <TabContent activeTab={activeTab} className="mt-3">
        <TabPane tabId={VENDOR_ORDERS_TABS.SOLD_AND_PURCHASE}>
          {activeTab === VENDOR_ORDERS_TABS.SOLD_AND_PURCHASE && (
            <VendorOrderSoldAndPurchase />
          )}
        </TabPane>

        <TabPane tabId={VENDOR_ORDERS_TABS.PAYMENT}>
          {activeTab === VENDOR_ORDERS_TABS.PAYMENT && <VendorOrderPayment />}
        </TabPane>
      </TabContent>
    </div>
  );
};

export default VendorOrders;
